<template>
  <window-container class="doc-po-edit card" style="width:960px;margin:0 auto;background-color:#fff;">
    <table style="font-size:18px;font-weight:bold;">
      <tr>
        <td style="padding:6px 0;">Purchase Order</td>
        <td style="padding:6px 0;text-align:right;">No.:
          <span v-if="form.id === 0" style="color:#838383;font-style:italic;">- NEW -</span>
          <span v-else>{{ form.id }}</span>
        </td>
      </tr>
    </table>
    <table class="table-border">
      <tr>
        <td class="td-border" style="padding:10px;width:430px;">
          <table>
            <tr>
              <td colspan="2" style="font-weight:bold;">*Vendor:</td>
            </tr>
            <tr>
              <td colspan="2">
                <el-input v-model="form.company_name" style="width:340px;"></el-input>
                &nbsp;
                <el-button @click="csVisible = true">...</el-button>
              </td>
            </tr>
            <tr>
              <td colspan="2"><el-input type="textarea" v-model="form.company_address" :rows="4"></el-input></td>
            </tr>
            <tr>
              <td style="text-align:right;width:60px;font-weight:bold;">*ATTN:</td>
              <td>
                <el-input v-model="form.contact_name" style="width:160px;"></el-input>
              </td>
            </tr>
            <tr>
              <td style="text-align:right;font-weight:bold;">*TEL:</td>
              <td>
                <el-input v-model="form.contact_phone" style="width:160px;"></el-input>
              </td>
            </tr>
            <tr>
              <td style="text-align:right;font-weight:bold;">FAX:</td>
              <td>
                <el-input v-model="form.contact_fax" style="width:160px;"></el-input>
              </td>
            </tr>
          </table>
        </td>
        <td class="td-border td-label" style="width:100px;text-align:center;">
          <el-button icon="el-icon-arrow-right" @click="form.shipping_address = form.company_address"></el-button>
        </td>
        <td class="td-border td-label" style="vertical-align:top;padding:10px;">
          *Ship To:<br/>
          <el-input type="textarea" v-model="form.shipping_address" :rows="6"></el-input><br/>
        </td>
      </tr>
    </table>
    <table style="width:100%;border-top:1px solid #CCC;border-left:1px solid #CCC;margin-top:10px;">
      <tr>
        <td colspan="4" class="td-border td-right td-padding">
          <span style="font-weight:bold;">Date:</span>&nbsp;<el-date-picker v-model="form.doc_date" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions" style="width:160px;"></el-date-picker>
        </td>
      </tr>
      <tr>
        <td class="td-border td-center td-padding td-label" style="width:230px;">Vendor PI No.</td>
        <td class="td-border td-center td-padding td-label" style="width:230px;">Payment Terms</td>
        <td class="td-border td-center td-padding td-label" style="width:230px;">Forwarder</td>
        <td class="td-border td-center td-padding td-label">Delivery Date</td>
      </tr>
      <tr>
        <td class="td-border td-center td-padding"><el-input v-model="form.customer_no"></el-input></td>
        <td class="td-border td-center td-padding">
          <!-- el-input v-model="form.payment_terms"></el-input -->
          <el-select 
            v-model="form.payment_terms"
            filterable 
            allow-create
            style="width:220px;"
            placeholder="">
            <el-option 
              v-for="item in paymentTerms" 
              :key="item" 
              :label="item" 
              :value="item"
              style="font-size:12px;height:16px;line-height:16px;">
            </el-option>
          </el-select>
        </td>
        <td class="td-border td-center td-padding"><el-input v-model="form.forwarder"></el-input></td>
        <td class="td-border td-center td-padding"><el-date-picker v-model="form.delivery_date" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions" style="width:160px;"></el-date-picker>&nbsp;<el-button @click="form.delivery_date = new Date()">Today</el-button></td>
      </tr>
    </table>
    <table class="table-border" style="margin-top:10px;">
      <tr>
        <td class="td-border td-label">No.</td>
        <td class="td-border td-label" colspan="3">Item</td>
        <td class="td-border td-label td-right">Qty</td>
        <td class="td-border td-label td-right">Unit Price</td>
        <td class="td-border td-label td-right">Amount</td>
      </tr>
      <tr>
        <td class="td-border">&nbsp;</td>
        <td class="td-border td-italic">Part Number</td>
        <td class="td-border td-italic">Description</td>
        <td class="td-border td-italic">Brand</td>
        <td class="td-border td-italic td-right">PCS</td>
        <td class="td-border td-italic td-right">
          <el-select v-model="form.currency" style="width:80px;" @change="changeCurrency">
            <el-option lable="USD" value="USD"></el-option>
            <el-option lable="HKD" value="HKD"></el-option>
            <el-option lable="RMB" value="RMB"></el-option>
          </el-select>
        </td>
        <td class="td-border td-italic td-right">{{ form.currency }}</td>
      </tr>
      <template v-for="(item, index) in productList">
        <tr :key="index + '_1'">
          <td rowspan="2" class="td-border" style="vertical-align:top;">
            <number-input v-model.number="productList[index].order_no" style="width:30px;"></number-input><br/>
            <el-button type="text" style="color:red;" @click="delProduct(index)" :disabled="form.is_locked === '1'">&nbsp;del</el-button>
          </td>
          <td class="td-border">{{ item.part_no }}</td>
          <td class="td-border"><el-input v-model="productList[index].description"></el-input></td>
          <td class="td-border">{{ item.brand }}</td>
          <td class="td-border td-right">{{ productList[index].qty }}</td>
          <td class="td-border td-right"><number-input v-model.number="productList[index].price" @input="inputPrice(index)"></number-input></td>
          <td class="td-border td-right" style="text-align:right;"><number-input v-model.number="productList[index].amount"></number-input></td>
        </tr>
        <tr :key="index + '_2'">
          <td colspan="2" class="td-border td-padding" style="vertical-align:top;">
            <el-input type="textarea" style="width:600px;" :rows="7" v-model="productList[index].remark" placeholder="remarks"></el-input>
          </td>
          <td colspan="2" class="td-border">
            <table style="width:100%;background-color:#c3ebff;">
              <tr>
                <td style="width:60px;">BB</td>
                <td style="text-align:right;"><number-input v-model.number="productList[index].qty_bb" @input="inputQty(index)"></number-input></td>
              </tr>
              <tr>
                <td>HK Stock</td>
                <td style="text-align:right;"><number-input v-model.number="productList[index].qty_hk" @input="inputQty(index)"></number-input></td>
              </tr>
              <tr>
                <td>SZ Stock</td>
                <td style="text-align:right;"><number-input v-model.number="productList[index].qty_sz" @input="inputQty(index)"></number-input></td>
              </tr>
            </table>
            <table style="width:100%;background-color:#c3ebff;">
              <tr>
                <td style="width:100px;">B2B Stock</td>
                <td style="text-align:right;">{{ productList[index].stock_bb || 0 }}</td>
              </tr>
              <tr>
                <td>HK Stock Qty</td>
                <td style="text-align:right;">{{ productList[index].stock_hk || 0 }}</td>
              </tr>
              <tr>
                <td>SZ Stock Qty</td>
                <td style="text-align:right;">{{ productList[index].stock_qty || 0 }}</td>
              </tr>
              <tr>
                <td>Incoming</td>
                <td style="text-align:right;">{{ productList[index].incoming_qty || 0 }}</td>
              </tr>
              <tr>
                <td>Reserved</td>
                <td style="text-align:right;">{{ productList[index].reserved_qty || 0 }}</td>
              </tr>
            </table>
          </td>
          <td colspan="2" class="td-border">&nbsp;</td>
        </tr>
      </template>
      <tr>
        <td colspan="5" class="td-border td-label td-right">INSURANCE CHARGE</td>
        <td class="td-border td-right">{{ form.currency }}</td>
        <td class="td-border">
          <number-input v-model.number="form.insurance_charge"></number-input>
        </td>
      </tr>
      <tr>
        <td colspan="5" class="td-border td-label td-right">DELIVERY CHARGE</td>
        <td class="td-border td-right">{{ form.currency }}</td>
        <td class="td-border">
          <number-input v-model.number="form.delivery_charge"></number-input>
        </td>
      </tr>
      <tr>
        <td colspan="5" class="td-border td-label td-right">OTHER CHARGE</td>
        <td class="td-border td-right">{{ form.currency }}</td>
        <td class="td-border">
          <number-input v-model.number="form.other_charge"></number-input>
        </td>
      </tr>
      <tr>
        <td colspan="5" class="td-border td-label td-right">TOTAL</td>
        <td class="td-border td-right">{{ form.currency }}</td>
        <td class="td-border td-right">{{ form.total_charge }}</td>
      </tr>
      <tr>
        <td colspan="4" class="td-border td-right">
          <span style="font-weight:bold;">Exchange Rate</span>&nbsp;=&nbsp;1&nbsp;:&nbsp;<number-input v-model.number="form.currency_rate_pay" style="width:40px"></number-input>
        </td>
        <td class="td-border td-label td-right">PAY BY</td>
        <td class="td-border td-right">
          <el-select v-model="form.pay_currency" style="width:70px;" @change="changePayCurrency">
            <el-option lable="USD" value="USD"></el-option>
            <el-option lable="HKD" value="HKD"></el-option>
            <el-option lable="RMB" value="RMB"></el-option>
          </el-select>
        </td>
        <td class="td-border td-right">{{ (form.total_charge * form.currency_rate_pay).toFixed(2) }}</td>
      </tr>
    </table>
    <table class="table-border" style="margin-top:10px;">
      <tr>
        <td class="td-border" style="padding:10px;">
          <strong>Remarks:</strong><br/>
          <el-input type="textarea" :rows="6" v-model="form.remarks"></el-input>
        </td>
        <td class="td-border" style="padding:10px;">
          <strong>Internal Remarks:</strong><br/>
          <el-input type="textarea" :rows="3" v-model="form.internal_remarks"></el-input><br/>
          <strong>E-Reach Number:</strong><br/>
          <el-input v-model="form.e_r_no"></el-input>
        </td>
      </tr>
      <tr>
        <td colspan="2" class="td-border" style="padding:10px;">
          <strong>Terms and Conditions:</strong><br/>
          <el-input type="textarea" :rows="7" v-model="form.terms"></el-input>
        </td>
      </tr>
      <tr>
        <td colspan="2" class="td-border" style="padding:10px;">
          <strong>Sales:</strong>&nbsp;
          <el-select v-model="form.sales_id" style="width:160px;">
            <el-option v-for="item in salesList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
          </el-select>
        </td>
      </tr>
    </table>
    <div style="padding:10px;margin:10px 0;">
      <el-button @click="save" :disabled="form.is_locked === '1'">Save</el-button>
      <el-button @click="reset" :disabled="form.is_locked === '1'">Reset</el-button>
      <el-button type="danger" @click="del" v-if="$route.params.id !== 'new'" :disabled="form.is_locked === '1'">Void</el-button>
    </div>
    <div v-if="form.is_locked === '1'" style="font-size:14px;font-weight:bold;">
      ***此单已锁，如需修改，请向管理员申请！
    </div>
    <el-dialog title="Contact Search" :visible.sync="csVisible" :close-on-click-modal="false">
      <div style="margin-top:-20px;margin-bottom:10px;">
        <el-input v-model="csQuery" style="width:320px;"></el-input>
        &nbsp;<el-button type="primary" @click="csSearch">&nbsp;Search&nbsp;</el-button>
      </div>
      <table class="cystron-table">
        <tr>
          <th>Name</th>
          <th>Contact</th>
          <th>Sales</th>
          <th>&nbsp;</th>
        </tr>
        <tr v-for="item in csList" :key="item.id">
          <td>{{ item.company_name }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.sales_name }}</td>
          <td><el-button type="text" @click="csChoose(item)">选择</el-button></td>
        </tr>
        <tr v-if="csList.length === 0">
          <td colspan="4" style="text-align:center;padding:10px 0;">输入关键字搜索联系人</td>
        </tr>
      </table>
    </el-dialog>
  </window-container>
</template>

<script>
import NumberInput from '@/components/NumberInput.vue'
import NP from 'number-precision'
import qs from 'qs'
export default {
  components: {
    NumberInput
  },
  data () {
    return {
      form: {
        id: this.$route.params.id === 'new' ? 0 : parseInt(this.$route.params.id),
        company_id: null,
        contact_id: null,
        company_name: '',
        company_address: '',
        shipping_address: `易达通实业(香港)有限公司E-Reach Industrial(HK).,Ltd
香港九龍觀塘鴻圖道79號 嘉士亞洲工業大廈 10樓A室
10/F Kras Asia Industrial Building 79 Hung To Road, Kwun Tong, Kowloon, Hong Kong
Tel: 852-3595 2155 Fax: 852-3595 2156
Attn: Winnie`,
        contact_name: '',
        contact_phone: '',
        contact_fax: '',
        customer_no: '',
        doc_date: new Date(),
        delivery_date: null,
        fob_point: '',
        payment_terms: '',
        forwarder: '',
        currency: 'USD',
        pay_currency: 'USD',
        insurance_charge: 0,
        delivery_charge: 0,
        other_charge: 0,
        total_charge: 0,
        currency_rate: 1,
        currency_rate_pay: 1,
        remarks: '',
        internal_remarks: '',
        e_r_no: '',
        terms: `1.	All goods must be new,unused,original factory sealed packing ,full original factory label and no oxidation. 
2.	All goods must meet manufacture's specification and function.
3.	Please use the most suitable box with foam material stuffed for package in case of damage during shipment.
4.	Delivery must be on time as required by us.
5.	Supplier need to provide Proforma Invoice with bank information.
6.	If the above conditions are not met,We have the rights to return the goods for refund.
7.	We have the right to claim compensation for the loss by the supplier’s problem.`,
        sales_id: null
      },
      usd_rmb_rate: 1,
      usd_hkd_rate: 1,
      productList: [],
      contactList: [],
      pickerOptions: {
        shortcuts: [{
          text: 'today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'a week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      csVisible: false,
      csQuery: '',
      csList: [],
      paymentTerms: [
        '10% deposit in advance',
        '15% deposit in advance',
        '20% deposit in advance',
        '25% deposit in advance',
        '30% deposit in advance',
        '40% deposit in advance',
        '50% deposit in advance',
        '10% deposit,balance T/T in advance',
        '20% deposit,balance T/T in advance',
        '25% deposit,balance T/T in advance',
        '20%deposit, balance T/T before delivery',
        '20%deposit, balance T/T before shipment',
        '20%deposit, balance COD by Cheque',
        '20%deposit, balance COD',
        '20%deposit, balance Net 1',
        '100% T/T in advance',
        '30% COD,balance net 7days',
        'By Cheque',
        'COD',
        'COD by Cheque',
        'COD by local bank transfer',
        'Cash',
        'Escrow',
        'Escrow-IC Source',
        'Escrow-Netcomponents',
        'Escrow-Hkin.com',
        'Local bank transfer',
        'Net 1 day',
        'Net 3 days',
        'Net 4 days',
        'Net 5 days',
        'Net 6 days',
        'Net 7 days',
        'Net 10 days',
        'Net 12 days',
        'Net 15 days',
        'Net 20 days',
        'Net 30 days',
        'Net 40 days',
        'Net 50 days',
        'Net 60 days',
        'Net 90 days',
        'Net 120 days',
        'T/T',
        'T/T against ainway bill',
        'T/T in advance',
        'T/T upon receipt',
        'T/T upon receipt of AWB',
        'T/T before delivery',
        'T/T after received goods'
      ]
    }
  },
  computed: {
    totalCharge () {
      let t = 0
      for (let i = 0; i < this.productList.length; i++) {
        t = NP.plus(t, parseFloat(this.productList[i].amount))
      }
      if (!isNaN(parseFloat(this.form.insurance_charge))) {
        t = NP.plus(t, parseFloat(this.form.insurance_charge))
      }
      if (!isNaN(parseFloat(this.form.delivery_charge))) {
        t = NP.plus(t, parseFloat(this.form.delivery_charge))
      }
      if (!isNaN(parseFloat(this.form.other_charge))) {
        t = NP.plus(t, parseFloat(this.form.other_charge))
      }
      return t
    },
    salesList () {
      return this.$store.state.select.sales
    }
  },
  watch: {
    'totalCharge' (v) {
      this.form.total_charge = v
    }
  },
  mounted () {
    this.fetchDoc()
    this.fetchProductList()
    this.$store.dispatch('fetchSelect', 'sales')
    this.loadRate()
  },
  methods: {
    loadRate () {
      this.$http.get('/dbapi/sys_settings').then(data => {
        if (data.list.length > 0) {
          this.usd_rmb_rate = data.list[0].po_usd_rmb_rate
          this.usd_hkd_rate = data.list[0].po_usd_hkd_rate
        }
      })
    },
    fetchDoc () {
      if (this.$route.params.id !== 'new') {
        this.$http.get('/dbapi/po_doc_list?id=' + this.$route.params.id).then(data => {
          if (data.list.length > 0) {
            let doc = data.list[0]
            this.form = { ...doc }
            this.form.currency_rate_pay = this.form.currency_rate
          } else {
            this.$message({
              type: 'error',
              message: data.message
            })
          }
        })
      }
    },
    fetchProductList () {
      if (this.$route.params.id !== 'new') {
        this.$http.get('/dbapi/po_doc_details?id=' + this.$route.params.id).then(data => {
          this.productList = data.list
          this.fetchCartProducts()
        })
      } else {
        this.productList = []
        this.fetchCartProducts()
      }
    },
    fetchCartProducts () {
      this.$http.get('/dbapi/cart_product_list').then(data => {
        let list = data.list
        for (let i = 0; i < list.length; i++) {
          list[i].id = 0
          list[i].qty = 0
          list[i].price = 0
          list[i].amount = 0
          list[i].qty_bb = 0
          list[i].qty_hk = 0
          list[i].qty_sz = 0
          list[i].remark = ''
          list[i].order_no = this.productList.length + 1
          this.productList.push(list[i])
        }
        this.fetchStockBalance()
      })
    },
    fetchStockBalance () {
      this.$http.get('/dbapi/stock_list', {
        params: {
          ids: this.productList.map(r => r.product_id)
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }).then(data => {
        let list = this.productList.slice()
        for (let i = 0; i < data.list.length; i++) {
          for (let j = 0; j < list.length; j++) {
            if (data.list[i].id === list[j].product_id) {
              list[j].stock_bb = data.list[i].stock_bb
              list[j].stock_hk = data.list[i].stock_hk
              list[j].stock_sz = data.list[i].stock_sz
              list[j].incoming_qty = data.list[i].incoming_qty
              list[j].reserved_qty = data.list[i].reserved_qty
              break;
            }
          }
        }
        this.productList = list
      })
    },
    searchContact (query) {
      this.$http.get('/dbapi/company_contact_combo', {
        params: {
          query,
          limit: 30
        }
      }).then(data => {
        this.contactList = data.list
      })
    },
    inputPrice (i) {
      this.productList[i].amount = (this.productList[i].qty * this.productList[i].price).toFixed(2)
    },
    inputQty (i) {
      let bb = 0
      let hk = 0
      let sz = 0
      try {
        bb = parseInt(this.productList[i].qty_bb)
        if (isNaN(bb)) {
          bb = 0
        }
      } catch (e) {}
      try {
        hk = parseInt(this.productList[i].qty_hk)
        if (isNaN(hk)) {
          hk = 0
        }
      } catch (e) {}
      try {
        sz = parseInt(this.productList[i].qty_sz)
        if (isNaN(sz)) {
          sz = 0
        }
      } catch (e) {}
      this.productList[i].qty =  bb + hk + sz
      this.productList[i].amount = (this.productList[i].qty * this.productList[i].price).toFixed(2)
    },
    changeCurrency (v) {
      this.form.pay_currency = v
    },
    changePayCurrency (v) {
      if (this.form.currency === 'USD') {
        if (v === 'USD') {
          this.form.currency_rate_pay = 1
        } else if (v === 'RMB') {
          this.form.currency_rate_pay = this.usd_rmb_rate
        } else if (v === 'HKD') {
          this.form.currency_rate_pay = this.usd_hkd_rate
        }
      }
    },
    save () {
      if (!this.form.company_id) {
        this.$message({
          type: 'error',
          message: 'Please select a company'
        })
        return
      }
      if (this.form.currency === 'RMB') {
        this.form.currency_rate = this.usd_rmb_rate
      } else if (this.form.currency === 'HKD') {
        this.form.currency_rate = this.usd_hkd_rate
      } else {
        this.form.currency_rate = 1
      }
      this.form.products = this.productList.map(p => {
        return {
          id: p.id || 0,
          product_id: p.product_id,
          qty: p.qty,
          price: p.price,
          amount: p.amount,
          qty_bb: p.qty_bb,
          qty_hk: p.qty_hk,
          qty_sz: p.qty_sz,
          remark: p.remark,
          order_no: p.order_no,
          description: p.description
        }
      })
      let url = '/dbapi/po_doc_insert'
      if (this.$route.params.id !== 'new') {
        url = '/dbapi/po_doc_update'
      }
      this.$http.post(url, this.form).then(data => {
        this.$message({
          type: 'success',
          message: 'Saved.'
        })
        this.$http.post('/dbapi/remove_cart_all') //清空购物车
        window.opener && window.opener.postMessage('cystron', '*') // 刷新主页列表
        if (this.$route.params.id !== 'new') {
          this.$router.push('/po-order-view/' + this.$route.params.id)
        } else {
          this.$router.push('/po-order-view/' + data.insertId)
        }
      })
    },
    reset () {
    },
    del () {
      this.$confirm('确定要作废吗?', 'Confirm', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/po_doc_del', { id: this.$route.params.id }).then(data => {
          this.$close()
        })
      })
    },
    delProduct (index) {
      this.$confirm('确定要删除吗?', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.productList[index].id > 0) {
          this.$http.post('/dbapi/po_del', { id: this.productList[index].id })
        }
        this.productList.splice(index, 1)
      })
    },
    csSearch () {
      this.$http.get('/dbapi/company_contact_list_2?limit=100&query=' + encodeURIComponent(this.csQuery)).then(data => {
        this.csList = data.list
      })
    },
    csChoose (contact) {
      this.csVisible = false
      this.form.company_id = contact.company_id
      this.form.company_name = contact.company_name
      this.form.company_address = contact.company_address
      // this.form.shipping_address = contact.ship_address || contact.company_address
      this.form.contact_name = contact.name
      this.form.contact_phone = contact.phone || contact.company_phone
      this.form.contact_fax = contact.fax || contact.company_fax
      this.form.sales_id = contact.sales_id
    }
  }
}
</script>

<style>
.doc-po-edit table {
  border-spacing: 0;
  width: 100%;
}
.doc-po-edit .table-border {
  border-top: 1px solid #CCC;
  border-left: 1px solid #CCC;
}
.doc-po-edit table td {
  padding: 2px;
}
.doc-po-edit .td-border {
  border-right: 1px solid #CCC;
  border-bottom: 1px solid #CCC;
}
.doc-po-edit .td-label {
  font-weight: bold;
}
.doc-po-edit .td-right {
  text-align: right;
}
.doc-po-edit .td-center {
  text-align: center;
}
.doc-po-edit .td-padding {
  padding: 4px;
}
.doc-po-edit .td-italic {
  font-style: italic;
}
.doc-po-edit .el-input__inner {
  border: 1px solid #9ba5bb
}
.doc-po-edit .el-textarea__inner {
  border: 1px solid #9ba5bb;
}
.doc-po-edit .el-input__inner:hover {
  border-color: #1b32a7;
}
.doc-po-edit .el-textarea__inner:hover {
  border-color: #1b32a7;
}
</style>
